// USED in videogallery2022.js, videoproduct2022.js, whybuyfromus2022.js, employment.js
class VideoTranscripts{
    constructor(){
        this.scriptButton = document.getElementById("showMoreTranscript");
        this.scriptText = document.getElementById("transcriptContainer");
        this.maxTranscriptHeight = 300; // must match value in videogallery SASS file

		this.toggle = this.toggle.bind(this);
		this.getHeight = this.getHeight.bind(this);
    }

	init(){
		if(this.scriptText && this.scriptButton){
            this.getHeight();
            this.scriptButton.addEventListener("click", this.toggle);
            window.addEventListener("resize", this.getHeight);
		}
	}

	toggle(e){
		e.preventDefault();
		if(this.scriptButton.getAttribute("aria-expanded") == "false") this.expand();
		else this.collapse();
	}

	expand(){
		this.show();
		this.scriptText.focus();
		this.scriptButton.textContent = "Hide Full Transcript";
	}

	collapse(){
		if(this.scriptButton){
			this.hide();
			this.scriptButton.textContent = "Show Full Transcript";
		}
	}

    show() {
        this.scriptButton.setAttribute("aria-expanded", "true");
		this.scriptText.classList.add("showAll");
    }

    hide() {
        this.scriptButton.setAttribute("aria-expanded", "false");
		this.scriptText.classList.remove("showAll");
    }

	getHeight() {
		//if the script is less than the max height set in videogallery sass file
		//show full transcript and hide the show full transcript button
		if(this.scriptText.offsetHeight < this.maxTranscriptHeight){
			this.show();
			this.scriptButton.classList.add("hide");
		}else if(this.scriptButton.classList.contains("hide")){
			this.hide();
			this.scriptButton.classList.remove("hide");
		}
	}
}

export default new VideoTranscripts();